import { truncateText } from "./Meetings.utils";

const MeetingSummaryCard = ({ meeting }) => {
  return (
    <p className="text-body-secondary mb-3">{truncateText(meeting?.summary || meeting?.transcript)}</p>
  );
};

export default MeetingSummaryCard;
